module.exports = __webpack_public_path__ + "static/media/microphone-black-shape.c037eed6.svg";